module.exports = __webpack_public_path__ + "img/lasers-2.2dbca67f.png";